export type Pos = {
  x: number
  y: number
}

export type TimeRange = {
  start: number
  end: number
}

export enum Action {
  None, // mouse outside canvas
  SelectingNewWindow, // select a new window
  MoveCurWindowLeft,
  MoveCurWindowRight,
  MoveCurWindow, // drag the current selected window
  ModifyTimeline
}

export type TimeWindowChangeListener = (timeRange: TimeRange) => void

export type TimelineChangeListener = (timeline: TimeRange) => void
